import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

export default createReactClass({
  displayName: 'Root',
  PropTypes: {
    user: PropTypes.object.isRequired,
  },
  render() {
    const user = this.props.user;
    return (
      <li key={user.id}>
        <div className="row align-items-start pt-3 pr-3 pl-3 pb-0">
          <div className="col-2 pl-0 pr-2">
            <img
              data-src={user.companies_user
                ? user.companies_user.avatar_thumb
                : user.avatar_thumb || ''}
              className="member-icon_48px rounded-circle ls-is-cached lazyloaded"
              src={user.companies_user
                ? user.companies_user.avatar_thumb
                : user.avatar_thumb || ''}
            />
          </div>
          {user.company ? (
            <div className="row col border-bottom pb-2 align-items-start cricle-member-name">
              <div className="col pl-0">
                <a
                  href={"/community/" + user.company.id_to_param + "/member/" + user.companies_user.member_id}
                  style={{ textDecoration: 'none' }}
                >
                  <p className="mb-0 text-fz-green text-fz-14px line-1">
                  @{user.companies_user
                      ? user.company.is_real_name_required 
                      ? user.companies_user.view_full_name_disp : 
                        user.companies_user.nickname
                    : "退会ユーザー"}
                  </p>
                </a>
              </div>
              <div className="col-7 p-0">
                <p
                  className="card-text--ellipsis text-fz-14px text-black-50 mb-0"
                  style={{ lineHeight: '1.71' }}
                >
                  {user.companies_user.introduction}
                </p>
              </div>
            </div>
          ) : (
            <div className="row col border-bottom pb-2 align-items-start cricle-member-name">
              <div className="col pl-0">
                <a
                  href={`/member/profile/${user.tunagate_id}`}
                  style={{ textDecoration: 'none' }}
                >
                  <p className="mb-0 text-fz-green text-fz-14px line-1">
                    {user.tunagate_id}
                  </p>
                </a>
              </div>
              <div className="col-7 p-0">
                <p
                  className="card-text--ellipsis text-fz-14px text-black-50 mb-0"
                  style={{ lineHeight: '1.71' }}
                >
                  {user.introduction}
                </p>
              </div>
            </div>
          )
          }
        </div>
      </li>
    );
  },
});
